import { Injectable } from '@angular/core';

/**
 * Servizio per centralizzare la gestione del localStorage.
 */
@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  public static readonly TOKEN_KEY = 'token';

  /**
   * Salva un valore.
   * @param key la chiave
   * @param value il valore
   */
  public storeItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  /**
   * Recupera un valore.
   * @param key la chiave con cui è stato salvato il valore.
   */
  public retrieveItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  /**
   * Rimuove un valore.
   * @param key la chiave con cui è stato salvato il valore.
   */
  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }

}
